import React from "react";
import useTitanApp from "../../hooks/useTitanApp";
import IconSVG from "./../../assets/images/icon-drug.svg";
import {
  Modal,
  Box,
  TextField,
} from "@mui/material";
import DrugSkeleton from "../../components/AddPrescriptionItem/DrugSkeleton";

const PrescriptionViewModal = ({
  show,
  handleClose,
}) => {
  const { appState, nmsServiceState } = useTitanApp();
  const { darkMode } = appState || {};
  const { viewPrescriptionData, isPrescriptionLoading } = nmsServiceState || {};

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    bgcolor: darkMode ? "#222" : "#fff",
    boxShadow: 24,
    borderRadius: "10px",
    paddingTop: "40px"
  };

  return (
    <Modal open={show}>
      <Box sx={style}>
        <div className="card-content ps-add-item">
          <div className="card-actions nms-title">
            <div className="d-flex">
              <IconSVG />
              <h2 className="medicine-card-heading">Medicine</h2>
            </div>
            <button
              onClick={handleClose}
              style={{ color: darkMode ? '#f2f2f2' : '#222' }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18M6 6l12 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icons-color"
                />
              </svg>
            </button>
          </div>

          {isPrescriptionLoading ? (
            <DrugSkeleton />
          ) : (
            <div className="view-prescription-content">
              {viewPrescriptionData?.length > 0 ? (
                Array.isArray(viewPrescriptionData) && viewPrescriptionData?.map((prescription, index) => (
                  <div key={prescription._id} className="view-prescription-wrapper">
                    {prescription.drugs.map((drug, i) => (
                      <div className="view-prescription-content-wrapper">
                        <div key={i} className="prescription-left-panel">
                          <input
                            type="text"
                            value={drug.drugName}
                            disabled
                          />
                          <div style={{ display: "flex", gap: "10px" }}>
                            <input
                              type="text"
                              value={drug.dose}
                              disabled
                            />
                            <input
                              type="number"
                              value={drug.quantity}
                              disabled
                            />
                          </div>
                          <textarea
                            value={drug.note}
                            disabled
                            rows={3}
                            style={{
                              border: 'none',
                              borderRadius: '10px',
                            }}
                          />
                        </div>
                        <div className="prescription-right-panel">
                          <div className="info-boxes" >
                            <div className="yellow-box">
                              <h2 className="medicine-card-heading">Contraindications</h2>
                              <p>Severe hepatic impairment, hypersensitivity to paracetamol.</p>
                            </div>
                            <div className="yellow-box">
                              <h2 className="medicine-card-heading">Warnings</h2>
                              <p>Avoid exceeding the recommended dose. Risk of liver damage with overdose or prolonged use.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <div className="view-prescription-wrapper">
                  <p>
                    No prescriptions found for this patient.
                  </p>
                </div>
              )}

            </div>
          )}

        </div>
      </Box>
    </Modal>
  );
};

export default PrescriptionViewModal;

